<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->

<h1 mat-dialog-title>{{tfsTitleText}}</h1>
<ng-container *ngIf="!showRecoveryCode; else showRecovery">

    <mat-dialog-content>
      <div class="setup">
        <ol>
            <li>{{tfsStepOne}}</li>
            <li>{{tfsStepTwo}}</li>
            <li>
                <span *ngIf="showBarCode; else manualEntry;">{{tfsStepThree}}</span>
                <ng-template #manualEntry>
                    <span>{{tfsStepThreeManual}}</span>
                </ng-template>
                <span *ngIf="key; else showSkeleton;">
                <div *ngIf="showBarCode; else showKey;">
                    <img src="data:image/png;base64,{{ qrcode }}" alt="QR Code"/>
                </div>
                <ng-template #showKey>
                    <div class="secret-key-info">
                        <div>{{tfsAccountName}}: <strong>{{ data.user.email }}</strong></div>
                        <div>{{tfsSecretKey}}: <strong>{{ getFormattedSecretKey(key) }}</strong> ({{tfsSpaces}})</div>
                    </div>
                </ng-template>
                <div>
                    <a class="show-hide-features" [routerLink]="[]"
                       (click)="showBarCode = !showBarCode"> {{showBarCode ? tfsNoScan : tfsScan}}
                    </a>
                </div>
            </span>
                <ng-template #showSkeleton>
                    <div style="padding: 25px 0 0 20px;">
                        <svg width="562" height="219">
                            <defs>
                                <linearGradient id="linear-gradient"
                                                x1="0%" y1="0%"
                                                x2="0%" y2="100%"
                                                spreadMethod="pad"
                                                gradientTransform="rotate(315)"
                                >
                                    <stop offset="0%" stop-color="#000" stop-opacity="1">
                                    </stop>
                                    <stop offset="100%" stop-color="#EEE" stop-opacity="1">
                                        <animate attributeName="offset" values="0.2;0.5;0.9;1" dur="0.85s" repeatCount="indefinite" />
                                    </stop>
                                </linearGradient>
                            </defs>
                            <rect width="180"
                                  height="180"
                                  stroke="#D5D5D5"
                                  stroke-width="8"
                                  style="fill:url(#linear-gradient);"/>
                        </svg>
                    </div>
                </ng-template>
            </li>
            <li>{{tfsStepFour}}
                <div><strong>{{tfsOtpCode}}</strong></div>
                <mat-form-field appearance="outline">
                    <input id="otp-input" matInput type="text" appAutofocus [formControl]="totpCode" (keyup.enter)="addVerifyTotp()">
                </mat-form-field>
                <div *ngIf="invalidToTP" class="alert">
                    <div>{{tfsInvalidOtpCode}}</div>
                </div>
                <div *ngIf="totpCheckFailed" class="alert">
                    <div>{{tfsFailedOtpCode}}</div>
                </div>
            </li>
        </ol>
      </div>
    </mat-dialog-content>
    <div mat-dialog-actions align="end">
        <button mat-raised-button (click)="onCancel()" class="cancel-button">{{tfsCancel}}</button>

          @if (verifying$ | async) {
            <button mat-raised-button [disabled]="true" class="check-2fa-button">
                <span class="mdi mdi-dots-circle mdi-spin verify-spinner"></span>
                <span>{{'VERIFYING' | translate}}</span>
            </button>
          } @else {
            <button mat-raised-button (click)="addVerifyTotp()" color="primary" class="check-2fa-button">
              <span>{{tfsNext}}</span>
            </button>
          }

    </div>
</ng-container>


<ng-template #showRecovery>
    <div class="enable">
        <p>{{tfsRecoveryTextOne}}</p>
        <div>
            <p>{{tfsRecoveryTextTwo}}</p>
            <ol>
                <ul>{{recoveryCode}}<button
                                        color="primary"
                                        mat-flat-button 
                                        (click)="onDownloadRecoveryCodeFile()" 
                                        class="download-button">{{tfsRecoveryDownload}}
                                    </button>
                </ul>
            </ol>
            <p>{{tfsRecoveryTextThree}}</p>
        </div>
    </div>
    <div mat-dialog-actions align="end">
        <button mat-raised-button (click)="onDoneClick()" color="primary" class="cancel-button">Done</button>
    </div>
</ng-template>